import { render, staticRenderFns } from "./pubRate.vue?vue&type=template&id=835806ba&scoped=true&"
import script from "./pubRate.vue?vue&type=script&lang=js&"
export * from "./pubRate.vue?vue&type=script&lang=js&"
import style0 from "./pubRate.vue?vue&type=style&index=0&id=835806ba&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835806ba",
  null
  
)

export default component.exports